export const PROPOSAL_TYPES: Array<{
  label: string;
  urlTitle: string;
  addrTitle: string;
  extraTitle: string;
  types: Array<{
    label: string;
    addrTitle: string;
    anyof?: string[];
    required?: string[];
    extraTitle: string;
  }>;
}> = [
  {
    label: 'Token',
    urlTitle: 'Official website of the token',
    addrTitle: 'Related 0x address',
    extraTitle: 'Additional information (optional)',
    types: [
      {
        label: 'Support new token',
        addrTitle: 'Token contract address',
        extraTitle: 'Token name',
        required: ['addrs'],
      },
      {
        label: 'Delist a token',
        addrTitle: 'Token contract address',
        extraTitle: 'Token name',
        required: ['addrs'],
      },
      // {
      //   label: 'Scam token',
      //   addrTitle: 'Token contract address',
      //   extraTitle: 'Token name',
      //   required: ['addrs'],
      // },
      {
        label: 'Token price error',
        addrTitle: 'Token contract address',
        extraTitle: 'Token name',
        required: ['addrs'],
      },
      {
        label: 'Update token info (logo, symbol)',
        extraTitle: 'Token name',
        addrTitle: 'Token contract address',
        required: ['addrs'],
      },
      {
        label: 'Other token issues',
        addrTitle: 'Token contract address',
        extraTitle: 'Additional information',
        anyof: ['urls', 'addrs'],
        required: ['addrs'],
      },
    ],
  },
  {
    label: 'DeFi Assets',
    urlTitle: 'Official website of the protocol',
    addrTitle: 'Related 0x address',
    extraTitle: 'Additional information (optional)',
    types: [
      {
        label: 'Support new protocol',
        addrTitle: 'Related 0x address (optional)',
        extraTitle: 'Protocol name',
        anyof: ['urls', 'addrs'],
      },
      {
        label: 'Delist a protocol',
        addrTitle: 'Related 0x address (optional)',
        extraTitle: 'Protocol name',
        anyof: ['urls', 'addrs'],
      },
      {
        label: 'Update protocol info',
        addrTitle: 'Related 0x address',
        extraTitle: 'Protocol name',
        anyof: ['urls', 'addrs'],
      },
      {
        label: 'Support new pool in protocol',
        addrTitle: 'Contract address(es) of the pool',
        extraTitle: 'Additional information (optional)',
        anyof: ['urls', 'addrs'],
      },
      {
        label: 'Delist pool from protocol',
        addrTitle: 'Contract address(es) of the pool',
        extraTitle: 'Additional information (optional)',
        anyof: ['urls', 'addrs'],
      },
      {
        label: 'Position error in protocol',
        addrTitle: 'Contract address(es) of the pool',
        extraTitle: 'Additional information (optional)',
        anyof: ['urls', 'addrs'],
      },
      {
        label: 'Other DeFi assets issues',
        addrTitle: 'Contract address(es) of the pool',
        extraTitle: 'Additional information',
        anyof: ['urls', 'addrs'],
      },
    ],
  },
  {
    label: 'NFT',
    urlTitle: 'Official website of the NFT collection',
    addrTitle: 'Related 0x address',
    extraTitle: 'Additional information (optional)',
    types: [
      {
        label: 'Support new NFT collection',
        addrTitle: 'Contract address(es) of the collection',
        extraTitle: 'Collection name',
        required: ['addrs'],
      },
      {
        label: 'Delist a NFT collection',
        addrTitle: 'Contract address(es) of the collection',
        extraTitle: 'Collection name',
        required: ['addrs'],
      },
      // {
      //   label: 'Scam NFT collection',
      //   addrTitle: 'Contract address(es) of the collection',
      //   extraTitle: 'Collection name',
      //   required: ['addrs'],
      // },
      {
        label: 'Update NFT image',
        addrTitle: 'Contract address(es) of the collection',
        extraTitle: 'Collection name',
        required: ['addrs'],
      },
      {
        label: 'Other NFT issues',
        addrTitle: 'Contract address(es) of the collection',
        extraTitle: 'Additional information',
        anyof: ['urls', 'addrs'],
        required: ['addrs'],
      },
    ],
  },
  {
    label: 'Chain',
    urlTitle: 'Official website of the chain',
    addrTitle: 'Related 0x address',
    extraTitle: 'Additional information (optional)',
    types: [
      {
        label: 'Support new chain',
        addrTitle: 'Related 0x address (optional)',
        extraTitle: 'Chain name',
        required: ['urls'],
      },
      {
        label: 'Other chain issues',
        addrTitle: 'Related 0x address (optional)',
        extraTitle: 'Additional information',
        required: ['urls'],
      },
    ],
  },
];
